import { EnvironmentInjector, inject, InjectionToken, Provider, Type } from '@angular/core';

import { Registry } from '../registry/registry';
import { AsyncRegistryInitializer, MaybePromise } from '../registry/registry.types';
import { ServicesRegistry } from './services-registry';

export function provideServicesRegistry<TService>(
  provideToken: InjectionToken<ServicesRegistry<TService>>,
  ...entryOrPreset: Array<AsyncRegistryInitializer<Type<TService>>>
): Provider {
  return {
    provide: provideToken,
    useFactory: () => {
      const parent = inject(provideToken, { skipSelf: true, optional: true });
      const registry = new Registry<MaybePromise<Type<TService>>>(parent?.registry ?? null);
      entryOrPreset.forEach((entryOrPresetFn) => entryOrPresetFn(registry));

      return new ServicesRegistry<TService>(registry, inject(EnvironmentInjector));
    },
  };
}
